<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.11.22</b> - Я выкладывал обновления практически каждый день, так что вот список
      всего, что было добавлено с последних заметок:
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Примечательные исправления багов
        <ul>
          <li>- Исправлен баг, не позволяющий игрокам продавать их стартовые сумки</li>
          <li>
            - Исправлены (только некоторые, видимо) баги ИИ, вызывающие бесконечные циклы в Пещеры
          </li>
          <li>
            - Исправлен баг, позволяющий игрокам пропускать уровни Пещеры спам-кликом по
            лестницам
          </li>
        </ul>
      </li>
      <li>
        Баланс
        <ul>
          <li>- Ребалансирован Сила в магии для снижения стоимости ОД</li>
          <li>
            - Нерф суффикса оружия "ужаса" для меньшего срабатывания и более короткой длительности
          </li>
          <li>
            - Увеличены бонусы характеристик средних и лёгких частей брони; увеличена
            AC щитов
          </li>
        </ul>
      </li>
      <li>Пещеры: увеличена минимальная ширина коридоров</li>
      <li>
        Ограничены области игры для новичков, начиная с Пещеры и
        постепенно разблокируя другие области
      </li>
      <li>Добавлена поддержка русского языка</li>
      <li>Иииии конечно исправлено много других багов, слишком многочисленных для упоминания</li>
    </ul>
  </div>
</template>
